import { styled, useTranslation } from '@obvio/app'
import { Button } from '@obvio/ui'

import { useLocalStorageEvent } from '@/utils/hooks/useLocalStorageEvent'

import type { AllowUndefinedForOptional } from '@obvio/utils'
import type { ReactElement } from 'react'

export const MoreBtn = styled(Button)`
  margin: 0 auto !important;
  margin-top: ${(theme) => theme.spacing.large} !important;
`

type RegisterMoreButtonProps = AllowUndefinedForOptional<{
  id: string
  modal?: boolean
  onNewClick?(): void
}>

export function RegisterMoreButton({
  id,
  modal = false,
  onNewClick,
}: RegisterMoreButtonProps): ReactElement {
  const { removeEvent } = useLocalStorageEvent()

  const { t } = useTranslation()

  return (
    <MoreBtn
      {...(!modal && { kind: 'ghost' })}
      onClick={() => {
        removeEvent(id)
        onNewClick?.()
      }}
    >
      {t('event.registerMore')}
    </MoreBtn>
  )
}
